export const KEYWORD_SPLIT_REGEX = /[\n,]/g;

export const normalizeKeyword = (value: string): string => value.trim();

export const normalizeKeywords = (values: string[]): string[] => {
  const seen = new Set<string>();
  const normalized: string[] = [];

  values.forEach((value) => {
    const trimmed = normalizeKeyword(value);
    if (!trimmed) return;

    const key = trimmed.toLocaleLowerCase();
    if (seen.has(key)) return;

    seen.add(key);
    normalized.push(trimmed);
  });

  return normalized;
};

export const parseKeywordsFromText = (value?: string): string[] => {
  if (!value) return [];
  return normalizeKeywords(value.split(KEYWORD_SPLIT_REGEX));
};

export const serializeKeywordsToText = (keywords?: string[]): string =>
  normalizeKeywords(keywords || []).join(", ");
